import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppShell } from "@/components/AppShell";
import { RiskBadge } from "@/components/SourceBadge";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Buildings, User, FileText, MagnifyingGlass } from "@phosphor-icons/react";

export default function Reports() {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);

  useEffect(() => {
    api.get("/reports").then((r) => setReports(r.data.reports)).catch(() => {});
  }, []);

  return (
    <AppShell breadcrumb="Report">
      <div className="max-w-5xl">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="font-heading text-3xl font-extrabold tracking-tight text-zinc-950">Report</h1>
            <p className="text-sm text-zinc-500 mt-1">Archivio dei report di due diligence emessi.</p>
          </div>
          <Button data-testid="reports-new" onClick={() => navigate("/app/new")} className="bg-zinc-950 text-white hover:bg-zinc-800 rounded-sm gap-2">
            <MagnifyingGlass size={16} weight="bold" /> Nuova indagine
          </Button>
        </div>

        {reports.length === 0 ? (
          <div className="border border-dashed border-zinc-300 rounded-sm p-12 text-center text-sm text-zinc-500">
            Nessun report presente in archivio.
          </div>
        ) : (
          <div className="bg-white border border-zinc-200 rounded-sm divide-y divide-zinc-100" data-testid="reports-list">
            {reports.map((r) => (
              <button key={r.id} data-testid={`report-row-${r.id}`} onClick={() => navigate(`/app/report/${r.id}`)}
                className="w-full flex items-center gap-4 px-5 py-3.5 hover:bg-zinc-50 transition-colors duration-150 text-left">
                <div className="w-9 h-9 rounded-sm bg-zinc-100 border border-zinc-200 flex items-center justify-center shrink-0">
                  {r.entity_type === "corporate" ? <Buildings size={16} className="text-zinc-600" /> : <User size={16} className="text-zinc-600" />}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="font-medium text-zinc-900 truncate">{r.target_name}</div>
                  <div className="text-xs text-zinc-500 font-mono truncate">{r.business_purpose_label}</div>
                </div>
                <div className="text-xs text-zinc-400 font-mono hidden sm:block">
                  {new Date(r.created_at).toLocaleDateString("it-IT")}
                </div>
                <RiskBadge level={r.risk_level} />
                <FileText size={16} className="text-zinc-300" />
              </button>
            ))}
          </div>
        )}
      </div>
    </AppShell>
  );
}
